import { render, staticRenderFns } from "./ProtocolQueryHistoryPopup.vue?vue&type=template&id=34a8d985&scoped=true&"
import script from "./ProtocolQueryHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./ProtocolQueryHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a8d985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a8d985')) {
      api.createRecord('34a8d985', component.options)
    } else {
      api.reload('34a8d985', component.options)
    }
    module.hot.accept("./ProtocolQueryHistoryPopup.vue?vue&type=template&id=34a8d985&scoped=true&", function () {
      api.rerender('34a8d985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/ProtocolQueryHistoryPopup.vue"
export default component.exports